import { render, staticRenderFns } from "./DocutaxOfficeAssignmentEdit.vue?vue&type=template&id=e6099dea&"
import script from "./DocutaxOfficeAssignmentEdit.vue?vue&type=script&lang=js&"
export * from "./DocutaxOfficeAssignmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports